<div class="user-profile-settings-container no-select">

  <div class="widget-div">

    @if (canAccountSettingsBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canAccountSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canAccountSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Default Order Formula</div>
          <app-display-icon
            [tooltip]="tooltips.defaultOrderFormula"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formAccountSettings">

            @if (formAccountSettings?.controls['stockDays']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="stockDays" class="required-field">Stock Days</label>
                  <input
                    [class.invalid]="formAccountSettings?.controls['stockDays']?.errors"
                    [formControlName]="'stockDays'"
                    id="stockDays"
                    placeholder="Days of stock to cover (e.g. 30)"
                    type="number"/>
                </div>
              </div>
            }

            @if (formAccountSettings?.controls['growth']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="growth" class="required-field">Growth Estimation (%)</label>
                  <input
                    [class.invalid]="formAccountSettings?.controls['growth']?.errors"
                    [formControlName]="'growth'"
                    id="growth"
                    placeholder="Additional stock percentage (e.g. 10)"
                    type="number"/>
                </div>
              </div>
            }

            @if (formAccountSettings?.controls['monthsHistory']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="monthsHistory" class="required-field">Months of History</label>
                  <input
                    [class.invalid]="formAccountSettings?.controls['monthsHistory']?.errors"
                    [formControlName]="'monthsHistory'"
                    id="monthsHistory"
                    placeholder="Months of sales history (e.g. 3)"
                    type="number"/>
                </div>
              </div>
            }

            @if (formAccountSettings?.controls['period']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="period" class="required-field">Ordering Method</label>
                  <app-shared-custom-select
                    id="period"
                    (selectionChange)="onPeriodChange($event)"
                    [allowMultiple]="false"
                    [placeholder]="'Select ordering method...'"
                    [setOptions]="getPeriodOptions()"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasAccountSettingsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canAccountSettingsBeEdited === false"
              (click)="onRevertForm('accountSettings')">
              <app-display-icon
                [colour]="canAccountSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canAccountSettingsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isAccountSettingsSubmitDisabled"
              (click)="onSubmitForm('accountSettings')">
              <app-display-icon
                [colour]="isAccountSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  @if (!hideActionBar) {
  <div class="ups-container-action-bar widget-actions">
    @if (hasAccountSettingsErrors?.length > 0) {
      @for (field of hasAccountSettingsErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>
  }

</div>
